import * as React from "react";
import {Container} from "semantic-ui-react";

export const PublicLayout = (props) => {
    return <div className="App">
        <Container>
            {props.children}
        </Container>
    </div>
};